var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("gb-zb-choice " + (_vm.content.disabled === true ? 'gb-zb-disabled' : '')),on:{"click":_vm.handleChoice}},[_vm._v(" "+_vm._s(_vm.content.item.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }